import { createContext, useContext } from 'react';
import type { MonarchEvaluationsValue } from '../../../pages';

export const ExperienceDataContext = createContext<MonarchEvaluationsValue | undefined>(undefined);

export const useExperienceData = () => {
  const context = useContext(ExperienceDataContext);
  return context;
};
